import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";
const name = "operation";

export const getOperations = () => {
  return requestGet(`${name}`);
};

export const createOperation = (param) => {
  return requestPost(`${name}`, param);
};

export const updateOperation = (id, param) => {
  return requestPut(`${name}/${id}`, param);
};

export const deleteOperation = (id) => {
  return requestDelete(`${name}/${id}`);
};